<template>
    <fieldset>
        <p>
            OBS! Det är ej lämpligt att koppla fler än en integration av denna
            typ till en profil.
        </p>

        <template v-if="oauthDone">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Access Token</div>
                </div>
                <textarea
                    type="text"
                    class="form-control"
                    required
                    v-model="accessToken"
                    @input="onUpdate"
                    rows="5"
                >
                </textarea>
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Refresh Token</div>
                </div>
                <input
                    type="text"
                    class="form-control"
                    required
                    v-model="refreshToken"
                    @input="onUpdate"
                />
            </div>

            <div class="mb-3">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            Skapa kontakt i HubSpot om den saknas
                        </div>
                    </div>
                    <select
                        class="custom-select"
                        v-model="createHubspotContact"
                        @change="onUpdate"
                        required
                    >
                        <option :value="false">Nej</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>
            </div>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">Fältnamn</div>
                </div>
                <input
                    type="text"
                    class="form-control"
                    v-model="quoteUrlPropertyName"
                    @input="onUpdate"
                    required
                />
            </div>
        </template>

        <oauth-auth-code-workflow
            v-else
            provider="Hubspot"
            :initiator="route('integrations.hubspot.auth.initiate')"
            @success="handleOauthSuccess"
            @failure="handleOauthFailure"
        />
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import OauthAuthCodeWorkflow from "../oauth-auth-code-workflow.vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const accessToken = ref(null);
const refreshToken = ref(null);
const lastUpdated = ref(null);
const createHubspotContact = ref(null);
const quoteUrlPropertyName = ref(null);
const oauthDone = computed(() => {
  return accessToken.value && refreshToken.value;
});
const serializedValue = computed(() => {
  return {
    access_token: accessToken.value,
    refresh_token: refreshToken.value,
    last_updated: lastUpdated.value,
    create_hubspot_contact: createHubspotContact.value,
    quote_url_property_name: quoteUrlPropertyName.value
  };
});
function handleOauthSuccess([newAccessToken, newRefreshToken]) {
  accessToken.value = newAccessToken;
  refreshToken.value = newRefreshToken;
  lastUpdated.value = new Date().toISOString().slice(0, 19).replace("T", " ");
  onUpdate();
}
function handleOauthFailure(error) {
  console.log(error);
}
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    accessToken.value = modelValue.value.access_token;
    refreshToken.value = modelValue.value.refresh_token;
    lastUpdated.value = modelValue.value.last_updated;
    createHubspotContact.value = modelValue.value.create_hubspot_contact;
    quoteUrlPropertyName.value = modelValue.value.quote_url_property_name;
    if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
      onUpdate();
    }
  }
}, {
  immediate: true
});
watch(() => props.defaultMode, () => {
  // Using this because of @input was faster than v-model on checkbox
    emit("update:modelValue", serializedValue.value);
});
</script>
